// extracted by mini-css-extract-plugin
module.exports = {"card":"Chart_card__2ULej","cardInfo":"Chart_cardInfo__YCD0d","text":"Chart_text__bKMiF"};